import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconChevronLeftLarge = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M15.54 4.477c.14.14.21.32.21.539 0 .203-.07.375-.21.515L9.07 12l6.47 6.469c.14.14.21.32.21.539 0 .203-.07.375-.21.515a.741.741 0 0 1-.54.235.741.741 0 0 1-.54-.235l-6.632-6.632A1.217 1.217 0 0 1 7.453 12c0-.344.125-.64.375-.89l6.633-6.633A.741.741 0 0 1 15 4.242c.203 0 .383.078.54.235z" }),
});

export { IconChevronLeftLarge };
